export default "__VITE_ASSET__Cql2zViS__"